'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _deep = require('helpers/deep');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VenueDeriver = function () {
  function VenueDeriver() {
    (0, _classCallCheck3.default)(this, VenueDeriver);
  }

  (0, _createClass3.default)(VenueDeriver, null, [{
    key: 'address',
    value: function address(venue) {
      return (0, _keys2.default)((venue ? venue.address : null) || {}).map(function (key) {
        return venue.address[key];
      }).filter(function (val) {
        return !!val;
      }).join(', ');
    }
  }, {
    key: 'sellExperienceMapper',
    value: function sellExperienceMapper(rawVenue) {
      var venue = ['id', 'location', 'name', 'subtitle', 'activities', 'images'].reduce(function (memo, key) {
        return (0, _extends4.default)({}, memo, (0, _defineProperty3.default)({}, key, rawVenue[key]));
      }, {});

      delete venue.location.name;
      delete venue.location.parent_name;

      if (venue.images) {
        delete venue.images.mobile;
      }

      return venue;
    }
  }, {
    key: 'splitActivities',
    value: function splitActivities(venue) {
      if (venue && venue.activities && venue.activities.split) {
        venue.activities = venue.activities.split(',').map(function (str) {
          return str.trim();
        });
      }
    }
  }, {
    key: 'mobileImage',
    value: function mobileImage(venue, key) {
      return venue.images && venue.images.mobile && venue.images.mobile[key];
    }
  }, {
    key: 'getCountryShortCode',
    value: function getCountryShortCode(venue) {
      return (0, _deep.deepExtract)('global_location.msa.country.short_code', venue);
    }
  }]);
  return VenueDeriver;
}();

exports.default = VenueDeriver;